import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const EXTERNALLINKBUTTONBLOCK_LEGACY_FIELD_ORDER = [
  "type",
  "level",
  "url",
  "target",
  "size"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  externalLinkButtonBlockDescriptor: _generatedExternalLinkButtonBlockDescriptor,
  externalLinkButtonBlockBlocDefinition,
  externalLinkButtonBlockDashboardLayout,
  externalLinkButtonBlockConfig,
  externalLinkButtonBlockResolveConfig,
  externalLinkButtonBlockProperties,
} = doodBlockConfig(
  {
    name: "External Link Button",
    componentType: 'ExternalLinkButtonBlockComponent',
    category: 'content',
    description: "External Link Button.",
    keywords: [],
    allowedIn: [
      { bloc: "UserFeedbackBlockComponent", slot: "modal_positive_rating_content" },
      { bloc: "UserFeedbackBlockComponent", slot: "modal_negative_rating_content" },
    ],
    sharedFields: {},
    slots: [
      {
        key: 'content',
        name: 'pages.blocks.external-link-button.content.label',
        accept: 'explicitOnly',
        allowedTypes: ["TextBlock", "ImageVariableWidthBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    type: propertyValue({
      type: 'select',
      value: "normal",
      options: {
        label: "pages.blocks.external-link-button.type.label",
        multiple: false,
        choices: [
          {
            value: "normal",
            label: "pages.blocks.external-link-button.type.options.normal",
          },
          {
            value: "light",
            label: "pages.blocks.external-link-button.type.options.light",
          },
          {
            value: "outlined",
            label: "pages.blocks.external-link-button.type.options.outlined",
          },
          {
            value: "text",
            label: "pages.blocks.external-link-button.type.options.text",
          },
        ],
      },
    }),
    level: propertyValue({
      type: 'select',
      value: "primary",
      options: {
        label: "pages.blocks.external-link-button.level.label",
        multiple: false,
        choices: [
          {
            value: "primary",
            label: "pages.blocks.external-link-button.level.options.primary",
          },
          {
            value: "neutral",
            label: "pages.blocks.external-link-button.level.options.neutral",
          },
          {
            value: "success",
            label: "pages.blocks.external-link-button.level.options.success",
          },
          {
            value: "info",
            label: "pages.blocks.external-link-button.level.options.info",
          },
          {
            value: "error",
            label: "pages.blocks.external-link-button.level.options.error",
          },
          {
            value: "highlight",
            label: "pages.blocks.external-link-button.level.options.highlight",
          },
        ],
      },
    }),
    url: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.external-link-button.url.label",
      },
    }),
    target: propertyValue({
      type: 'select',
      value: "_blank",
      options: {
        label: "pages.blocks.external-link-button.target.label",
        multiple: false,
        help: "pages.blocks.external-link-button.target.help",
        choices: [
          {
            value: "_blank",
            label: "pages.blocks.external-link-button.target.options._blank",
          },
          {
            value: "_self",
            label: "pages.blocks.external-link-button.target.options._self",
          },
        ],
      },
    }),
    size: propertyValue({
      type: 'select',
      value: "md",
      options: {
        label: "pages.blocks.external-link-button.size.label",
        multiple: false,
        choices: [
          {
            value: "sm",
            label: "pages.blocks.external-link-button.size.options.sm",
          },
          {
            value: "md",
            label: "pages.blocks.external-link-button.size.options.md",
          },
          {
            value: "lg",
            label: "pages.blocks.external-link-button.size.options.lg",
          },
          {
            value: "xl",
            label: "pages.blocks.external-link-button.size.options.xl",
          },
        ],
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.external-link-button.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.external-link-button.fieldset.link.label",
            fields: ["url", "target", "content"],
          },
          {
            legend: "pages.blocks.external-link-button.fieldset.appearance.label",
            fields: ["type", "size", "level"],
          },
        ],
      },
    ],
  })
);

export function externalLinkButtonBlockDescriptor(): IBlockDescriptor;
export function externalLinkButtonBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function externalLinkButtonBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedExternalLinkButtonBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedExternalLinkButtonBlockDescriptor, externalLinkButtonBlockProperties, fieldOrder);
}

export {
  externalLinkButtonBlockBlocDefinition,
  externalLinkButtonBlockDashboardLayout,
  externalLinkButtonBlockProperties,
  externalLinkButtonBlockConfig,
  externalLinkButtonBlockResolveConfig,
};

export type ExternalLinkButtonBlockConfig = typeof externalLinkButtonBlockConfig;
